import React, { useState, ChangeEvent, useRef } from "react";
import { HStack, VStack, Select, Box, Text, Button, Textarea } from '@chakra-ui/react';
import { User, Work } from "@/pbgen/v1/main_pb";
import {client} from "@/client"
import { NavigateFunction } from "react-router-dom"; // useNavigate の型
import { bearerToken } from "@/auth";

import './CommentComponent.css';

interface ItemComponentProps {
  user: User;
}

export const CommentComponent: React.FC<ItemComponentProps> = ({ user }) => {
  const [localUser, setLocalUser] = useState<User>(user);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [isEditMode, setEditMode] = useState(false);

  return <VStack className="comment_box">
    <Textarea fontSize={"xs"}
      ref={textareaRef} 
      value={localUser.optComment}
      disabled={!isEditMode}
      style={{
        display: "block",
        height: isEditMode ? "300px" : "96px",
        resize: "none",
        fontSize: "16px",
      }}

      onChange={(e) => setLocalUser({ ...localUser, optComment: e.target.value } as User)}
    ></Textarea>

    <Button onClick={async () => {
      if (isEditMode) {
        const resp = client.saveUser({
          bearerToken: bearerToken(),
          user: localUser,
        });
        setEditMode(false);
    } else {
        setEditMode(true);
    }
    }}>
    {isEditMode ? "保存" : "編集"}
    </Button>

  </VStack>
}

